import {Style,  RegularShape, Fill, Stroke} from 'ol/style';

import regular from './regular.js'

export const star = async (styleDef,layer,__style) => {
	var __layer = Object.assign({},layer);
	__layer.point = __layer.point || 5;
	__layer.radius = styleDef.size/2 * (__layer.ratio || 1);
	__layer.innerRadius = (__layer.sharpness ? (1 - Math.max(0,Math.min(1,__layer.sharpness))) : 0.5) * __layer.radius;

	return await regular(styleDef,__layer,__style);
};

export  default star;